// extracted by mini-css-extract-plugin
module.exports = {"popupRow":"List_popupRow_3X-0u","pagination":"List_pagination_1IIvK","paginationText":"List_paginationText_27isk","paginationButton":"List_paginationButton_22v3E"};